<qvs-login-page-header></qvs-login-page-header>
<div class="qvs-login-qr">
  <p class="qvs-login-qr__contract-number">
    {{ 'ebanking.login.CONTRACT_NUMBER' | translate }}&nbsp;<span class="qvs-login-qr__contract-number--secondary">{{
      contractNumber$ | async
    }}</span>
  </p>
  @if (isQRCodeExpired$ | async) {
    <div class="qvs-login-qr__warning-wrapper">
      <div class="qvs-login-qr__warning-wrapper__image-wrapper">
        <img class="qvs-login-qr__warning-wrapper__image-wrapper__image" [src]="dataUri" [alt]="'login QR code'" />
      </div>
      <div class="qvs-login-qr__warning-wrapper__image-overlay">
        <qvs-registration-error
          [title]="'ebanking.login.QR_CODE_EXPIRED_TITLE' | translate"
          [paragraphOne]="'ebanking.login.QR_CODE_EXPIRED_DESC' | translate"
          [buttonText]="'ebanking.login.QR_CODE_BUTTON_TEXT' | translate"
          [disableBackground]="true"
          [isButtonDisabled]="isGenerateNewQRCodeButtonDisabled"
          (buttonClick)="generateNewQRCode()"
        ></qvs-registration-error>
      </div>
    </div>
  } @else {
    <img
      class="qvs-login-qr__image"
      [ngClass]="(isAuthenticationInProgress$ | async) && !isDataUriLoading ? '' : 'qvs-login-qr__image-blur'"
      [src]="dataUri"
      [alt]="'login QR code'"
    />
  }

  <div class="qvs-login-qr__description" [style.visibility]="(isQRCodeExpired$ | async) ? 'hidden' : 'visible'">
    <qvs-svg-icon
      class="qvs-login-qr__description__icon"
      [src]="descriptionIcon$ | async"
      [title]="'payment-scan-icon'"
    ></qvs-svg-icon>
    <p class="qvs-login-qr__description__text">{{ description$ | async | translate }}</p>
  </div>
</div>
